// @flow
import * as React from 'react';
import {BodyMono} from 'sail/Text';
import {Executable} from './_executable';
import {Stripe} from './stripe';
import {clear} from './clear';
import {exit} from './exit';
import {cd} from './cd';
import {ls} from './ls';
import {pwd} from './pwd';
import {feedback} from './feedback';
import {InputCommand} from '../terminal/command';

const availableInHelp = [cd, clear, exit, feedback, ls, pwd, Stripe];

const Help = (props: {helpText: string}) => {
  return (
    <BodyMono color="gray200">
      <pre>
        {`${props.helpText}`}
        {'\n\n'}
        {'Flags:\n   -h, --help\tmore help details'}
      </pre>
    </BodyMono>
  );
};

export class help extends Executable {
  help(): React.Node {
    this.setAllowInput(true);
    return '';
  }

  run(): React.Node {
    this.setAllowInput(true);

    let text = '';
    availableInHelp.forEach((exec) => {
      const executable = new exec(new InputCommand(''), this.setAllowInput);
      const shortHelp = executable.shortHelp();
      const command = executable.commandName();
      let tabs = '\t\t';
      if (command.length > 6) {
        tabs = '\t';
      }
      text = `${text}\n${command}${tabs}${shortHelp}`;
    });

    return <Help helpText={text} />;
  }
}
